import { useQuery } from '@tanstack/react-query';
import { sessionGroupStore } from '../store/sessionGroupStore';
import {
  SESSION_GROUP_QUERY_GC_TIME,
  SESSION_GROUP_QUERY_STALE_TIME,
} from './constants';
import { sessionGroupQueryKey } from './keys';

export const sessionGroupQueryOptions = (groupId?: string | null) => ({
  queryKey: sessionGroupQueryKey(groupId),
  queryFn: () => sessionGroupStore.getGroup(groupId!),
  enabled: Boolean(groupId),
  staleTime: SESSION_GROUP_QUERY_STALE_TIME,
  gcTime: SESSION_GROUP_QUERY_GC_TIME,
  refetchOnWindowFocus: false,
});

export const useSessionGroupQuery = (groupId?: string | null) =>
  useQuery(sessionGroupQueryOptions(groupId));
